import type { SxProps, Theme } from "@mui/material/styles";
import {
  BACKGROUND_DARK,
  MAX_WIDTH,
  SIDE_PADDING,
  TOP_PADDING,
} from "../../theme/consts";
import { generalSectionSx } from "../../components/Layout";

export const pageSx: SxProps<Theme> = {
  backgroundColor: BACKGROUND_DARK,
  minHeight: "100vh",
};

export const containerSx: SxProps<Theme> = {
  ...generalSectionSx,
  "& p, & li, span, h2, h1, a": {
    color: "#ffffff",
    lineHeight: 1.4,
  },
};

export const mainTitleSx: SxProps<Theme> = {
  fontSize: { xs: "1.75rem", md: "2.25rem" },
  fontWeight: 600,
};

export const sectionTitleSx: SxProps<Theme> = {
  fontSize: { xs: "1.25rem", md: "1.5rem" },
  fontWeight: 600,
};

export const sectionTextSx: SxProps<Theme> = {
  fontSize: { xs: "0.875rem", md: "1rem" },
};

export const listSx: SxProps<Theme> = {
  ...sectionTextSx,
  lineHeight: 1.8,
  paddingLeft: "1.5rem",
  "& li": {
    marginBottom: "0.25rem",
  },
};
